import { useState } from 'react'
import { Modal } from '@mantine/core'

export default function ProductionOrderImage({ src, name }) {
    const [failedSrc, setFailedSrc] = useState(null)
    const [opened, setOpened] = useState(false)

    if (!src || failedSrc === src) return null

    return (
        <>
            <button
                type="button"
                onClick={() => setOpened(true)}
                aria-label={`Agrandir le visuel de ${name}`}
                aria-haspopup="dialog"
                className="h-24 w-24 shrink-0 cursor-zoom-in rounded-lg bg-white p-1 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-baltic"
            >
                <img
                    src={src}
                    alt=""
                    width={96}
                    height={96}
                    loading="lazy"
                    className="h-full w-full object-contain"
                    onError={() => setFailedSrc(src)}
                />
            </button>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title={name}
                size="lg"
                centered
                closeButtonProps={{ 'aria-label': 'Fermer le visuel' }}
            >
                <img
                    src={src}
                    alt={name}
                    className="max-h-[75vh] w-full object-contain"
                />
            </Modal>
        </>
    )
}
